import axios from 'axios'
import _ from 'lodash'
import { MessageBox } from 'element-ui'
import router from '@/router'
import i18n from '@/locales'
import defaultErrorCodeList from '@/constants/defaultErrorCode'
import constants from '@/constants'

let expiredCount = 0
let networkCount = 0
let econnabortedCount = 0
let errorCodeCount = 0
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // url = base url + request url
  timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem('authToken')
    const locale = localStorage.getItem('lang')
    config.headers['X-Auth-Token'] = authToken
    config.headers['X-Locale'] = locale || 'en'
    // let data = {
    //   extra: {
    //     channel: localStorage.getItem('extraChannel'),
    //     locale: locale || 'en'
    //   }
    // }
    let data = {}
    if (config.noJson) {
      data = {
        ...config.data
      }
    } else {
      data = {
        json: {
          ...config.data
        },
        extra: {
          channel: localStorage.getItem('extraChannel'),
          locale: locale || 'en'
        }
      }
    }
    config.data = data
    if (config.method === 'get') {
      config.params = config.data
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    if(constants.RESPONSE_DIRECT_RETURN_ROUTERS.includes(router.currentRoute.name)){
      // 直接返回结果
      return response.data
    }
    if (response.config.type === 'file') {
      // 文件类型
      return response.data
    }
    const res = response.data
    if (res?.metadata?.status !== '0000') {
      if (defaultErrorCodeList.includes(res.metadata.status)) {
        if (errorCodeCount > 0) {
          return
        }
        errorCodeCount++
        MessageBox.alert(`Error: Error Code ${res.metadata.status}`,
          i18n.t('common.alert.default.title'),
        {
          confirmButtonText: i18n.t('common.confirm'),
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          callback: () => {
          },
          onClose: () => {
            errorCodeCount--
          }
        })
      }
      if (['KKPAR-API-2', 'KKPAR-API-4'].includes(res.metadata.status)) {
        // token失效
        if (expiredCount > 0) {
          return
        }
        if (!['/', '/home', '/zh-tw', '/en', '/ja', '/ko'].includes(router.currentRoute.path)) {
          expiredCount++
          MessageBox.alert(i18n.t('common.alert.SESSION_EXPIRED.message'),
            i18n.t('common.alert.SESSION_EXPIRED.title'),
          {
            confirmButtonText: i18n.t('common.confirm'),
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            callback: () => {
              router.push({ path: '/login' })
            },
            onClose: () => {
              expiredCount--
            }
          })
        }
      }
      if (['KKPAR-API-67'].includes(res.metadata.status)) {
        // 沒有權限
        router.push({ path: '/no-permission' })
      }
    }
    return res
  },
  (error) => {
    if(constants.RESPONSE_DIRECT_RETURN_ROUTERS.includes(router.currentRoute.name)){
      // 直接返回结果
      return
    }
    const errStatus = _.get(error, 'response.status')
    if (!errStatus) {
      if (error.code === 'ECONNABORTED') {
        // aborted or timeout, what to do?
        if (econnabortedCount) {
          return
        }
        econnabortedCount++
        MessageBox.alert(i18n.t('common.alert.default.message', {errorCode: error.code}),
          i18n.t('common.alert.default.title'),
        {
          confirmButtonText: i18n.t('common.confirm'),
          callback: () => {
          },
          onClose() {
            econnabortedCount--
          }
        })
      } else {
        if (networkCount) {
          return
        }
        networkCount++
        MessageBox.alert(i18n.t('common.alert.NETWORK_ERROR.message'),
          i18n.t('common.alert.NETWORK_ERROR.title'),
        {
          confirmButtonText: i18n.t('common.confirm'),
          callback: () => {
          },
          onClose() {
            networkCount--
          }
        })
      }
    } else if (errStatus === 401) {
      if (expiredCount > 0) {
        return
      }
      expiredCount++
      MessageBox.alert(i18n.t('common.alert.SESSION_EXPIRED.message'),
        i18n.t('common.alert.SESSION_EXPIRED.title'),
      {
        confirmButtonText: i18n.t('common.confirm'),
        callback: () => {
        },
        onClose() {
          expiredCount--
        }
      })
    } else {
      if (networkCount) {
        return
      }
      networkCount++
      MessageBox.alert(i18n.t('common.alert.NETWORK_ERROR.message'),
        i18n.t('common.alert.NETWORK_ERROR.title'),
      {
        confirmButtonText: i18n.t('common.confirm'),
        callback: () => {
        },
        onClose() {
          networkCount--
        }
      })
    }
    return Promise.reject(error)
  }
)

export default service
